import { Footer } from "../../../components/footers/Footer"
import { FooterBanner } from "../../../components/footers/FooterBanner"
import { HomeHeader } from "../../../components/headers/HomeHeader"
import { RiteCharleeDashboard } from "../../../components/Contents/ritecharleepage/RiteCharleeDashboard"
import { RiteCharleeSections } from "../../../components/Contents/ritecharleepage/RiteCharleeSections"
import { RiteCharleeHero } from "../../../components/heros/RiteCharleeHero"
import SplitType from "split-type"
import gsap from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import TextPlugin from "gsap/TextPlugin"
import { useGSAP } from "@gsap/react"
import { useRef } from "react"

gsap.registerPlugin(useGSAP, ScrollTrigger, TextPlugin)
export const RiteCharlee = () => {
  const riteCharleeRef = useRef()

  useGSAP(
    () => {
      const riteCharleeLogo = gsap.utils.toArray(".riteCharlee-logo")
      const riteCharleeLogoTxt = new SplitType(".riteCharlee-logoTxt", {
        types: "lines, words, chars",
        tagName: "h5",
      })
      const riteCharleeHead = new SplitType(".riteCharlee-head", {
        types: "lines, words, chars",
        tagName: "h2",
      })
      const riteCharleeText = new SplitType(".riteCharlee-text", {
        types: "lines, words, chars",
        tagName: "p",
      })
      const riteCharleeBook = gsap.utils.toArray(".riteCharlee-book")
      const riteCharleeBoard = gsap.utils.toArray(".riteCharlee-board")

      const heroTimeline = gsap.timeline()
      heroTimeline.fromTo(
        riteCharleeLogo[0],
        { opacity: 0, clipPath: "circle(0%)" },
        { opacity: 1, clipPath: "circle(100%)", duration: 1 }
      )
      heroTimeline.fromTo(
        riteCharleeLogoTxt.chars,
        { opacity: 0 },
        { opacity: 1, stagger: 0.05, duration: 0.5, ease: "power4.out" },
        "+=0"
      )
      heroTimeline.fromTo(
        riteCharleeHead.chars,
        { y: "-100%", opacity: 0 },
        { y: "0%", opacity: 1, stagger: 0.05, duration: 0.5 },
        "+=0"
      )
      heroTimeline.fromTo(
        riteCharleeText.lines,
        { y: "-10%", opacity: 0 },
        { y: "0%", opacity: 1, stagger: 0.05, duration: 0.3 },
        "+=0"
      )
      heroTimeline.fromTo(riteCharleeBook, { opacity: 0 }, { opacity: 1, duration: 0.5 }, "+=0")
      heroTimeline.fromTo(
        riteCharleeBoard[0],
        { clipPath: "inset(100% 0% 0% 0%)", y: "50%", opacity: 0 },
        { clipPath: "inset(0% 0% 0% 0%)", y: "0%", opacity: 1, duration: 0.5 },
        "+=0"
      )

      const sections = [
        ".riteFeature-section",
        ".riteWorks-section",
        ".riteUseCases-section",
        ".riteBusiness-section",
        ".riteSecurity-section",
      ]

      sections.forEach((sectionClass) => {
        const sectionCards = gsap.utils.toArray(`${sectionClass} .rite-card`)

        ScrollTrigger.create({
          trigger: sectionClass,
          start: "-200px bottom",
          end: "bottom top",
          markers: false,
          scrub: 1,
          onEnter: () => {
            const sectionTimeline = gsap.timeline()
            sectionCards.forEach((card) => {
              sectionTimeline.fromTo(
                card,
                { y: "10%", opacity: 0 },
                { y: "0%", opacity: 1, duration: 0.3 },
                "+=0"
              )
            })
          },
        })
      })
    },
    { scope: riteCharleeRef }
  )

  return (
    <div className="w-full overflow-hidden bg-[#F9F9F9]">
      <HomeHeader headerColor={'#F9F9F9'} textColor={'#021744'}/>
      <div ref={riteCharleeRef} className="riteCharlee-page">
        <RiteCharleeHero />
        <RiteCharleeDashboard />
        <RiteCharleeSections />
      </div>
      <FooterBanner />
      <Footer />
    </div> 
  )
}